<p-panel
  [toggleable]="true"
  [collapsed]="breakpoints.isMobile()"
  i18n-header="@@conversations.filters.header"
  header="Filters"
  styleClass="filters-panel-wrapper">
  <div class="filters-grid">
    <div class="filter-item">
      <label for="calls-date-after" i18n="@@conversations.filter.dateAfter">Date After</label>
      <p-datepicker
        id="calls-date-after"
        [ngModel]="dateAfter()"
        (ngModelChange)="dateAfter.set($event)"
        (onSelect)="onFilterChange()"
        (onClear)="onFilterChange()"
        [showClear]="true"
        i18n-placeholder="@@conversations.filter.selectDate"
        placeholder="Select date"
        class="filter-datepicker">
      </p-datepicker>
    </div>

    <div class="filter-item">
      <label for="calls-date-before" i18n="@@conversations.filter.dateBefore">Date Before</label>
      <p-datepicker
        id="calls-date-before"
        [ngModel]="dateBefore()"
        (ngModelChange)="dateBefore.set($event)"
        (onSelect)="onFilterChange()"
        (onClear)="onFilterChange()"
        [showClear]="true"
        i18n-placeholder="@@conversations.filter.selectDate"
        placeholder="Select date"
        class="filter-datepicker">
      </p-datepicker>
    </div>

    <div class="filter-item">
      <label for="call-status-filter" i18n="@@conversations.filter.status">Status</label>
      <p-select
        id="call-status-filter"
        [ngModel]="selectedStatus()"
        (ngModelChange)="selectedStatus.set($event)"
        [options]="statusOptions"
        optionLabel="label"
        optionValue="value"
        i18n-placeholder="@@conversations.filter.allStatuses"
        placeholder="All statuses"
        [showClear]="true"
        (onChange)="onFilterChange()"
        class="filter-select">
      </p-select>
    </div>

    <div class="filter-item">
      <label for="calls-agent-filter" i18n="@@conversations.filter.agent">Agent</label>
      <p-select
        id="calls-agent-filter"
        [ngModel]="selectedAgentId()"
        (ngModelChange)="selectedAgentId.set($event)"
        [options]="agentOptions()"
        optionLabel="label"
        optionValue="value"
        i18n-placeholder="@@conversations.filter.allAgents"
        placeholder="All agents"
        [showClear]="true"
        (onChange)="onFilterChange()"
        class="filter-select">
      </p-select>
    </div>
  </div>
</p-panel>

<!-- Список звонков. cdk-virtual-scroll вместо виртуального скроллера
     PrimeNG — тот сбрасывал прокрутку в начало на каждой подгрузке
     страницы (подробнее — в sessions-list.component.html). -->
<div class="list-wrapper">
  <div class="list-head hide-mobile" role="presentation">
    <span i18n="@@conversations.col.date">Date</span>
    <span i18n="@@conversations.col.agent">Agent</span>
    <span i18n="@@conversations.callsCol.to">To</span>
    <span i18n="@@conversations.col.duration">Duration</span>
    <span i18n="@@conversations.col.status">Status</span>
    <span i18n="@@conversations.callsCol.endReason">End reason</span>
  </div>

  <cdk-virtual-scroll-viewport
    #viewport
    class="list-viewport"
    [itemSize]="rowHeight()"
    [minBufferPx]="rowHeight() * 6"
    [maxBufferPx]="rowHeight() * 12"
    (scrolledIndexChange)="onScrolledIndexChange($event, viewport.getViewportSize())">
    <a
      *cdkVirtualFor="let row of calls(); trackBy: trackById"
      class="list-row"
      [style.height.px]="rowHeight()"
      [routerLink]="['/calls', row.id]">
      <span class="cell cell-date">
        <span class="hide-mobile">{{ row.created_at | date:'MMM d, yyyy, h:mm a' }}</span>
        <span class="show-mobile">{{ row.created_at | date:'dd.MM HH:mm' }}</span>
      </span>
      <span class="cell cell-agent">{{ row.agent_title || unknownAgentLabel }}</span>
      <span class="cell cell-to">{{ row.to_phone_number || '-' }}</span>
      <span class="cell cell-duration">{{ formatDuration(row.duration_seconds) }}</span>
      <span class="cell cell-status">
        <p-tag
          [value]="getStatusLabel(row.status)"
          [severity]="getStatusSeverity(row.status)">
        </p-tag>
      </span>
      <span class="cell cell-reason hide-mobile">
        @if (row.end_reason) {
          <p-tag
            [value]="getEndReasonLabel(row.end_reason)"
            [severity]="getEndReasonSeverity(row.end_reason)">
          </p-tag>
        } @else {
          -
        }
      </span>
    </a>
  </cdk-virtual-scroll-viewport>

  @if (isLoading()) {
    <div class="list-status" role="status">
      <p-progressSpinner [style]="{ width: '24px', height: '24px' }" strokeWidth="4" />
    </div>
  } @else if (!calls().length) {
    <div class="list-status list-empty" i18n="@@conversations.callsEmpty">No calls found</div>
  } @else if (!hasMore()) {
    <div class="list-status list-end" i18n="@@conversations.endOfList">End of list</div>
  }
</div>
